import { HasPrivilegeDirective } from '@core/directives/has-privilege.directive';
import { HasRoleDirective } from '@core/directives/has-role.directive';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IsExpiredDirective } from './is-expired.directive';
import { IsNotReadOnlyDirective } from './is-not-readonly.directive';

@NgModule({
  imports: [
    CommonModule,
    HasRoleDirective,
    HasPrivilegeDirective,
    IsExpiredDirective,
    IsNotReadOnlyDirective,
  ],
  declarations: [],
  exports: [
    HasRoleDirective,
    HasPrivilegeDirective,
    IsExpiredDirective,
    IsNotReadOnlyDirective,
  ],
})
export class MyDirectiveModule {}
